import { useState, useEffect } from 'react'
import { toast } from "sonner";
import useSelectedDomain from '../../service/Hooks/useSelectedDomain';
import { cancelOrder, completeOrder, deleteOrder, getOrdersRfiByDomainId, partiallyCompleteOrder } from '../../service/api/Order';
import { getGravatarUrl } from '../../service/api/gravatar';

export default function ListeOrdreRfi({ initialOrders }) {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const selectedDomain = useSelectedDomain();
    const [currentPage, setCurrentPage] = useState(1); // Page actuelle
    const [ordersPerPage] = useState(5); // Nombre d'éléments par page
    const [selectedStatusFilter, setSelectedStatusFilter] = useState(null); // Ajout de l'état pour le filtre de statut
    const [orderss, setOrderss] = useState(initialOrders);
    const refreshInterval = 5000; // Rafraîchissement toutes les 5 secondes
    
    // gerer le format des dates
    function formatDate(dateString) {
        const date = new Date(dateString);
        const options = { day: 'numeric', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('fr-FR', options);
    }

    const handleCompleteOrder = async (orderId) => {
        // console.log("🔹 Début handleCompleteOrder pour :", orderId);
        try {
            const success = await completeOrder(orderId);
            if (success) {
                toast.success("L'ordre a été complété avec succès !");
                setOrders((prevOrders) => {
                    const newOrders = prevOrders.map((order) =>
                        order.id === orderId ? { ...order, status: "Completed" } : order
                    );
                    return newOrders;
                });
            }
        } catch (error) {
            toast.error(error.message || "Une erreur est survenue.");
        }
    };
    

    // Gérer la complétion partielle d'un ordre
    const handlePartialOrder = async (orderId) => {
        try {
        const success = await partiallyCompleteOrder(orderId);
        if (success) {
            toast.warn("L'ordre a été partiellement complété.");
            setOrders((prevOrders) =>
            prevOrders.map((order) =>
                order.id === orderId ? { ...order, status: "Partial" } : order
            )
            );
        }
        } catch (error) {
        toast.error(error.message || "Une erreur est survenue.");
        }
    };

    useEffect(() => {
       if (!selectedDomain || !selectedDomain.id) {
           return;
       }
   
       let isMounted = true; 
       setLoading(true);
       setError(null);
   
       const fetchOrders = async () => {
           try {
               const data = await getOrdersRfiByDomainId(selectedDomain.id);
               if (isMounted) {
                   setOrders((prevOrders) => {
                       // Vérifier si les nouvelles commandes sont différentes des précédentes
                       const isSameData = JSON.stringify(prevOrders) === JSON.stringify(data);
                       return isSameData ? prevOrders : data;
                   });
                   setLoading(false);
               }
           } catch (err) {
               if (isMounted) {
                   setError("Erreur lors de la récupération des données.");
                   setLoading(false);
               }
           }
       };
   
       fetchOrders(); 
   
       const interval = setInterval(fetchOrders, refreshInterval);
   
       return () => {
           isMounted = false; 
           clearInterval(interval); 
       };
    }, [selectedDomain]); 

     // Fonction pour afficher la couleur du statut
    const getStatusClass = (status) => {
        switch (status) {  // On enlève .toLowerCase() pour ne pas altérer les majuscules
          case 'Completed':
            return 'bg-success text-white'; // Vert pour 'Completed'
          case 'Pending':
            return 'bg-warning text-dark'; // Jaune pour 'Pending'
          case 'Canceled':
            return 'bg-secondary text-white'; // Rouge pour 'Canceled'
          case 'Partially':
            return 'bg-info text-white'; // Bleu clair pour 'PartiallyFilled'
            case 'Echec Completed':
                return 'bg-danger text-white'; // Bleu clair pour 'PartiallyFilled'
          default:
            return 'bg-secondary text-white'; // Gris par défaut
        }
    };

    // Gérer l'annulation d'un ordre
    const handleCancelOrder = async (orderId) => {
        try {
        const success = await cancelOrder(orderId);
        if (success) {
            toast.error("L'ordre a été annulé avec success.");
            setOrders((prevOrders) =>
            prevOrders.map((order) =>
                order.id === orderId ? { ...order, status: "Canceled" } : order
            )
            );
        }
        } catch (error) {
        toast.error(error.message || "Une erreur est survenue.");
        }
    };

  //   supprimer un order
    const handleDeleteOrder = async (orderId) => {
        try {
        const success = await deleteOrder(orderId);
        if (success) {
            toast.success("L'ordre a été supprimé avec succès !");
            setOrders((prevOrders) => prevOrders.filter((order) => order.id !== orderId));
        }
        } catch (error) {
        toast.error(error.message || "Une erreur est survenue.");
        }
    };

    // Fonction pour filtrer les commandes par statut
    const filteredOrders = selectedStatusFilter
        ? orders.filter((order) => order.status === selectedStatusFilter)
        : orders;

    // Calculer l'index de la première et de la dernière commande de la page
    const indexOfLastOrder = currentPage * ordersPerPage;
    const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
    const currentOrders = filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);

    // Calculer le nombre total de pages
    const totalPages = Math.ceil(filteredOrders.length / ordersPerPage);

    // Gérer le changement de page
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Gérer le changement de filtre de statut
    const handleStatusFilterChange = (status) => {
        setSelectedStatusFilter(status);
        setCurrentPage(1); // Réinitialiser la page lors du changement de filtre
    };

  return (
    <div>
        <br /><br />
         <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-header">
                    <h4
          className="fw-bold text-primary fs-4 text-uppercase m-0"
          style={{
            letterSpacing: "1px",
            textShadow: "1px 1px 2px rgba(0, 0, 0, 0.2)"
                              }}> Liste des commandes envoyées pour RFI</h4>
                          {!loading && !error && orders.length !== 0 && (
                            <div className="mt-4">
                                <button
                                    className={`btn btn-sm ${selectedStatusFilter === null ? 'btn-primary' : 'btn-outline-primary'} me-2`}
                                    onClick={() => handleStatusFilterChange(null)}
                                >
                                    Tous
                                  </button>
                                <button
                                    className={`btn btn-sm ${selectedStatusFilter === 'Completed' ? 'bg-success text-white' : 'btn-outline-success'} me-2`}
                                    onClick={() => handleStatusFilterChange('Completed')}
                                >
                                    Completed
                                </button>
                                <button
                                    className={`btn btn-sm ${selectedStatusFilter === 'Pending' ? 'bg-warning text-dark' : 'btn-outline-warning'} me-2`}
                                    onClick={() => handleStatusFilterChange('Pending')}
                                >
                                    Pending
                                </button>
                                <button
                                    className={`btn btn-sm ${selectedStatusFilter === 'Canceled' ? 'bg-secondary text-white' : 'btn-outline-secondary'} me-2`}
                                    onClick={() => handleStatusFilterChange('Canceled')}
                                >
                                    Canceled
                                </button>
                                <button
                                    className={`btn btn-sm ${selectedStatusFilter === 'Partially' ? 'bg-info text-white' : 'btn-outline-info'} me-2`}
                                    onClick={() => handleStatusFilterChange('Partially')}
                                >
                                    Partially
                                </button>
                                <button
                                    className={`btn btn-sm ${selectedStatusFilter === 'Echec Completed' ? 'bg-danger text-white' : 'btn-outline-danger'} me-2`}
                                    onClick={() => handleStatusFilterChange('Echec Completed')}
                                >
                                    Echec Completed
                                </button>
                            </div>
                        )}
                    </div>

                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-responsive-md table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th>RfiSide</th>
                                        <th>Utilisateur</th>
                                        <th >Prix</th>
                                        <th>Quantitée</th>
                                        <th>Status</th>
                                        <th>CreationDate</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentOrders.map((order) => (
                                        <tr>
                                            <td>
                                                <span className={`badge rounded bg-${order.rfiName === 'Buy' ? 'success' : 'danger'}`}>
                                                    {order.rfiName}
                                                </span>
                                            </td>                       
                                            <td><div className="d-flex align-items-center"><img src={getGravatarUrl(order.accountName)} className="rounded-circle img-fluid border m-2" width="30" alt="Profil"/><span className="w-space-no">{order.accountName}</span></div></td>
                                            <td className="py-2"> 
                                            <span className="badge bg-light text-dark px-2">
                                                {new Intl.NumberFormat("fr-FR", {
                                                style: "decimal",
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0,
                                                useGrouping: true
                                                }).format( order.price||0)} Fcfa
                                            </span>
                                            </td>
                                            <td style={{textAlign:"center"}}>{order.quantity}</td>
                                            <td>
                                                <span className={`badge rounded-pill ${getStatusClass(order.status)}`}>
                                                    {order.status}
                                                </span>
                                            </td>
                                            <td>{formatDate(order.creationDate)}</td>
                                            <td className="py-2 text-end">
                                                <div className="dropdown text-sans-serif"><button className="btn btn-primary tp-btn-light sharp" type="button" id="order-dropdown-0" data-bs-toggle="dropdown" data-boundary="viewport" aria-haspopup="true" aria-expanded="false"><span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18px" height="18px" viewBox="0 0 24 24" version="1.1"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><rect x="0" y="0" width="24" height="24"></rect><circle fill="#000000" cx="5" cy="12" r="2"></circle><circle fill="#000000" cx="12" cy="12" r="2"></circle><circle fill="#000000" cx="19" cy="12" r="2"></circle></g></svg></span></button>
                                                    <div className="dropdown-menu dropdown-menu-end border py-0" aria-labelledby="order-dropdown-0">
                                                        <div className="py-2">
                                                        {order.status !== "Completed" && order.status !== "Canceled" && (
                                                            <>
                                                                <a className="dropdown-item text-success" href="#" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleCompleteOrder(order.id);
                                                                    }}
                                                                >
                                                                    Completer  
                                                                </a>

                                                                <a className="dropdown-item text-warning" href="#"
                                                                        onClick={(e) => {
                                                                        e.preventDefault();
                                                                        handlePartialOrder(order.id);
                                                                    }}
                                                                >
                                                                    Partiel
                                                                </a>

                                                                <a
                                                                href="#"
                                                                    className="dropdown-item text-danger"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        handleCancelOrder(order.id);
                                                                    }}
                                                                >
                                                                    Annuler
                                                                </a>
                                                            </>
                                                        )}
                                                                

                                                        <div className="dropdown-divider"></div>
                                                        
                                                        <a className="dropdown-item text-danger" href="#"  
                                                                onClick={(e) => {
                                                                e.preventDefault(); // Empêche la navigation par défaut
                                                                handleDeleteOrder(order.id);
                                                            }}
                                                        >
                                                            <i className="fa fa-trash"></i>  Delete
                                                        </a>

                                                        <a className="dropdown-item text-success" href="javascript:void(0);"><i className="fa fa-pencil"></i>  edit</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    
                                </tbody>
                            </table>
                        </div>

                        {!loading && !error && orders.length === 0 && (
                            <div className="text-center text-muted">Aucune Commande lie a une (RFI)</div>
                        )}

                        {/* Pagination Bootstrap */}

                        {!loading && !error && orders.length > 0 && (
                            <nav>
                                <ul className="pagination justify-content-center">
                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        <i className="bi bi-chevron-left"></i> {/* Icône Suivant */}
                                    </button>
                                    </li>

                                    {/* Boucle pour afficher les numéros de page */}
                                    {[...Array(totalPages)].map((_, index) => (
                                    <li
                                        key={index + 1}
                                        className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
                                    >
                                        <button
                                        className="page-link"
                                        onClick={() => handlePageChange(index + 1)}
                                        >
                                        {index + 1}
                                        </button>
                                    </li>
                                    ))}

                                    <li
                                    className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}
                                    >
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        <i className="bi bi-chevron-right"></i> {/* Icône Suivant */}
                                    </button>
                                    </li>
                                </ul>
                            </nav>
                        )}
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
